import React, { Component } from "react";
import { range } from "lodash";
import CasePickerItem, { CasePickerItemStatus } from "../../components/CasePickerItem";

interface Props {
  cpp: number
  scanned: string[]
}

export default class PalletCases extends Component<Props> {
  constructor(props: Props) {
    super(props)
  }

  get cases () {
    const {cpp, scanned} = this.props
    const cases = range(1, cpp +1)
    return cases.map(caseNumber => {
      const isSelected = caseNumber > scanned.length
      const status: CasePickerItemStatus = isSelected ? 'available' : 'selected'
      return <CasePickerItem size="medium" status={status} key={caseNumber} />
    })
  }

  render () {
    return (
      <div className="flex gap-2 flex-wrap">
        {this.cases}
      </div>
    )
  }
}